import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { GlobalStateModel } from "../model/global.model";
import { GlobalState } from "../store/state/global.state";
import { USECASE } from "../model/usecase.model";
export abstract class Sandbox {
  @Select(GlobalState.getGlobal) global: Observable<GlobalStateModel>;
  @Select(GlobalState.getTypeContent) contentType: Observable<boolean>;
  @Select(GlobalState.getUseCase) usecase: Observable<USECASE>;

  constructor(store: Store) {}
}
